export const dealImportFr = {
  button: "Importer des deals",
  title: "Importer des deals (CSV)",
  help: "Colonnes : entreprise, téléphone, deal, étape, montant, source, catégorie, raison_perte, détail_perte, date_création (AAAA-MM-JJ), clôture_prévue, rep (courriel). Une 2e importation ignore les deals déjà présents.",
  file: "Fichier CSV",
  totals: "Totaux par étape",
  stage: "Étape",
  count: "Deals",
  amount: "Montant",
  issue: "Ligne %{line} : %{reason}",
  run: "Importer %{smart_count} deal |||| Importer %{smart_count} deals",
  summary: "%{created} créé, %{skipped} déjà présent, %{rejected} rejeté.",
  close: "Fermer",
  forbidden: "Importation réservée aux administrateurs.",
  failed: "L'importation a échoué.",
  ignored:
    "%{smart_count} ligne sera ignorée. |||| %{smart_count} lignes seront ignorées.",
  rejected: "Lignes rejetées",
  line: "Ligne",
  deal: "Deal",
  company: "Entreprise",
  reason: "Raison",
  reasons: {
    missing_column: "colonne obligatoire manquante : %{column}",
    extra_columns: "plus de colonnes que l'en-tête",
    malformed_row: "ligne mal formée",
    invalid_category: "catégorie inconnue",
    invalid_email: "courriel invalide",
    missing_company: "entreprise manquante",
    missing_name: "nom du deal manquant",
    invalid_stage: "étape inconnue",
    invalid_amount: "montant invalide (dollars entiers)",
    invalid_source: "source inconnue",
    invalid_loss_reason: "raison de perte inconnue",
    loss_reason_required: "raison de perte obligatoire pour « Perdu »",
    loss_detail_required: "détail obligatoire pour la raison « Autre »",
    invalid_date: "date invalide (AAAA-MM-JJ)",
    company_ambiguous: "plusieurs entreprises portent ce nom",
  },
};
